// @ts-nocheck -- staged migration: add explicit types before removing this directive.
const WANIKANI_API_BASE = "https://api.wanikani.com/v2";

export class WanikaniAuthError extends Error {
    constructor(message = "Invalid or expired WaniKani token.") {
        super(message);
        this.name = "WanikaniAuthError";
    }
}

async function wanikaniFetch(url, token) {
    const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
    });

    if (response.status === 401) {
        throw new WanikaniAuthError();
    }

    if (!response.ok) {
        throw new Error(`WaniKani API request failed with status ${response.status}`);
    }

    return response.json();
}

async function fetchAllPages(initialUrl, token) {
    const results = [];
    let url = initialUrl;

    while (url) {
        const page = await wanikaniFetch(url, token);
        results.push(...page.data);
        url = page.pages?.next_url || null;
    }

    return results;
}

export function validateToken(token) {
    return wanikaniFetch(`${WANIKANI_API_BASE}/user`, token);
}

export function fetchSummary(token) {
    return wanikaniFetch(`${WANIKANI_API_BASE}/summary`, token);
}

export function fetchAllAssignments(token) {
    return fetchAllPages(`${WANIKANI_API_BASE}/assignments?subject_types=kanji`, token);
}

export function fetchAllSubjects(token) {
    return fetchAllPages(`${WANIKANI_API_BASE}/subjects?types=kanji`, token);
}
